// Status colors are unified onto the design system's semantic palette
// (destructive / warning / success / primary) via shadcn-theme.scss's
// .q-badge[class*="bg-X"] rules. Keep these values as plain Quasar palette
// names — `red`, `yellow`, `green`, `blue` — so they hit those rules and
// pick up the readable `--*-badge-text` tokens in both light and dark mode.
export const PO_STATUSES = {
  canceled: {
    label: 'canceled',
    color: 'red',
    value: 'canceled',
  },
  deleted: {
    label: 'deleted',
    color: 'red',
    value: 'deleted',
  },
  invoiced: {
    label: 'invoiced',
    color: 'blue',
    value: 'invoiced',
  },
  open: {
    label: 'open',
    color: 'green',
    value: 'open',
  },
  partially_invoiced: {
    label: 'partially_invoiced',
    color: 'yellow',
    value: 'partially invoiced',
  },
  partially_received: {
    label: 'partially_received',
    color: 'yellow',
    value: 'partially received',
  },
  received: {
    label: 'received',
    color: 'blue',
    value: 'received',
  },
  rejected: {
    label: 'rejected',
    color: 'red',
    value: 'rejected',
  },
  unapproved: {
    label: 'unapproved',
    color: 'red',
    value: 'unapproved',
  },
  hold: {
    label: 'hold',
    color: 'red',
    value: 'hold',
  },
  closed: {
    label: 'closed',
    color: 'red',
    value: 'closed',
  },
};

export const PO_STATUS_MAPPING = {
  not_matched: 'po_not_matched',
  table_not_found: 'po_not_matched',
  purchase_order_not_found: 'po_not_matched',
  mismatch: 'po_mismatch',
  partial_matched: 'po_partial_matched',
  full_matched: 'po_full_matched',
  quantity_over_matched: 'po_over_matched',
  quantity_under_matched: 'po_under_matched',
  unit_price_over_matched: 'po_over_matched',
  unit_price_under_matched: 'po_under_matched',
  no_matchable_po_lines: 'po_no_matchable_po_lines',
};

export const NON_EXPENSE_DOC_TYPES = [
  // 'ORDER_CONFIRMATION',
  'SHIPMENT_NOTICE',
];

export const AMOUNT_COLUMNS = [
  'position',
  'price',
  'unit_price',
  'received_quantity',
  'quantity',
  'amount',
  'discount',
  'total_amount',
  'unit_price_per',
  'line_number',
  'sub_line_number',
  'order_total_amount',
  'delivery_number',
  'shipped_quantity',
  'invoiced_quantity',
  'invoice_open_quantity',
  'matched_quantity',
];

export const AUTO_EXPORT_PO_STATUSES = [
  'no_matchable_po_lines',
  'full_matched',
];

export const getStatusValue = (value) => {
  return String(PO_STATUS_MAPPING[value]);
};

export const getStatusColor = (status) => {
  status = status.replace(/ /g, '_');
  const item = PO_STATUSES[status];
  if (!item) {
    return '';
  }
  return String(item.color);
};
